
(function () {
  document.addEventListener('click', async function (event) {
    const button = event.target.closest('#update-gift-wrap');
    if (!button || button.disabled) return;

    const checkbox = document.getElementById('gift-wrapping');
    const message = document.getElementById('gift-note');

    if (!checkbox) return;

    const variantId = Number(checkbox.dataset.giftWrapVariant);
    if (!variantId) {
      alert('Gift wrapping product could not be found.');
      return;
    }

    button.disabled = true;
    button.textContent = 'Updating...';

    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: {
            [variantId]: checkbox.checked ? 1 : 0
          },
          attributes: {
            'gift-wrapping': checkbox.checked ? 'yes' : '',
            'gift-note': message ? message.value : ''
          }
        })
      });

      if (!response.ok) {
        throw new Error('Cart update failed');
      }

      window.location.reload();

    } catch (error) {
      console.error(error);
      alert('Unable to update your cart. Please try again.');
      button.disabled = false;
      button.textContent = 'Update Cart';
    }
  });
})();
